// --- Quiz Data ---
localStorage.removeItem("questionRecommendations");
localStorage.removeItem("userData");

const questions = [
  {
    text: "What are you looking for in a scent?",
    choices: [
      {
        text: "Something sweet",
        subtext: "(For lovers of warm, indulgent scents)",
        recommendations: { Vanilla: 8, Amber: 5, Jasmine: 3 },
      },
      {
        text: "Something unique",
        subtext: "(For those who love to stand out)",
        recommendations: { Coffee: 8, Jasmine: 5, Amber: 3 },
      },
      {
        text: "Something Fresh",
        subtext: "(For the crisp, clean scent enthusiasts)",
        recommendations: { Jasmine: 8, Coffee: 3 },
      },
      {
        text: "Something Sexy & Addictive",
        subtext: "(For those drawn to bold, captivating fragrances)",
        recommendations: { Amber: 8, Vanilla: 5 },
      },
    ],
  },
  {
    text: "If your perfume could set the mood, what are we going for?",
    choices: [
      {
        text: "Confident",
        subtext: "(Ready for anything the day brings)",
        recommendations: { Coffee: 8, Amber: 5, Vanilla: 3 },
      },
      {
        text: "Feminine",
        subtext: "(Graceful and elegant)",
        recommendations: { Jasmine: 8, Vanilla: 5 },
      },
      {
        text: "Cozy",
        subtext: "(Warm and comfortable)",
        recommendations: { Vanilla: 8, Coffee: 5, Jasmine: 3 },
      },
      {
        text: "Powerful",
        subtext: "(Bold and impactful)",
        recommendations: { Amber: 8, Coffee: 5 },
      },
    ],
  },
  {
    text: "Your signature drink says a lot about your signature scent...",
    choices: [
      {
        text: "Lemonade",
        subtext: "(Fresh and bright, perfect for sunny days)",
        recommendations: { Jasmine: 8, Vanilla: 5 },
      },
      {
        text: "Rosè",
        subtext: "(Light, elegant, and subtly sweet)",
        recommendations: { Vanilla: 8, Coffee: 3 },
      },
      {
        text: "Cappuccino",
        subtext: "(Rich, comforting, with a touch of luxury)",
        recommendations: { Coffee: 8, Vanilla: 5 },
      },
      {
        text: "Brandy ",
        subtext: "(Deep, sophisticated, and warming)",
        recommendations: { Jasmine: 8, Vanilla: 3 },
      },
    ],
  },
  {
    text: "Your perfect weather forecast looks like... ☀️",
    choices: [
      {
        text: "Summer",
        subtext: "(Bright days and warm evenings)",
        recommendations: { Jasmine: 8, Vanilla: 5 },
      },
      {
        text: "Autumn",
        subtext: "(Crisp air and cozy moments)",
        recommendations: { Vanilla: 8, Coffee: 3 },
      },
      {
        text: "Winter",
        subtext: "(Rich, warm embraces)",
        recommendations: { Coffee: 8, Vanilla: 5 },
      },
      {
        text: "Spring",
        subtext: "(Fresh blooms and new beginnings)",
        recommendations: { Jasmine: 8, Vanilla: 3 },
      },
    ],
  },
  {
    text: "The everyday scents that make you pause and smile...",
    choices: [
      {
        text: "Clean sheets",
        subtext: "(That fresh-from-the-dryer, wrapped-in-clouds feeling)",
        recommendations: { Jasmine: 8, Vanilla: 5 },
      },
      {
        text: "Salted caramel brownies",
        subtext: "(Warm, gooey happiness straight from the oven)",
        recommendations: { Vanilla: 8, Coffee: 3 },
      },
      {
        text: "Warm café",
        subtext: "(The cozy aroma that pulls you in from the street)",
        recommendations: { Coffee: 8, Vanilla: 5 },
      },
      {
        text: "Bouquet of flowers",
        subtext: "(Nature's perfume on your morning table)",
        recommendations: { Jasmine: 8, Vanilla: 3 },
      },
      {
        text: "Morning dew",
        subtext: "(That crisp first breath of a new day)",
        recommendations: { Jasmine: 8, Coffee: 3, Vanilla: 3 },
      },
      {
        text: "Christmas candle",
        subtext: "(Spiced warmth that feels like a holiday hug)",
        recommendations: { Coffee: 8, Amber: 5, Vanilla: 3 },
      },
      {
        text: "Hotel lobby",
        subtext: "(Luxurious first impressions that make you feel fancy)",
        recommendations: { Amber: 8, Jasmine: 5 },
      },
      {
        text: "Fresh Rain",
        subtext: "(Nature's reset button on a warm day)",
        recommendations: { Jasmine: 8 },
      },
      {
        text: "Incense",
        subtext: "(Ancient mysteries swirling in sacred smoke)",
        recommendations: { Amber: 8 },
      },
      {
        text: "Leather",
        subtext: "(Rich and refined, like stepping into a luxury car)",
        recommendations: { Amber: 8 },
      },
    ],
  },
  {
    text: "Spot any familiar favorites?",
    choices: [
      {
        text: "Baccarat Rouge",
        subtext: "",
        recommendations: { Amber: 8, Vanilla: 5 },
      },
      {
        text: "Burberry Goddess",
        subtext: "",
        recommendations: { Vanilla: 8, Jasmine: 5 },
      },
      {
        text: "Chanel Chance Eu tendre",
        subtext: "",
        recommendations: { Jasmine: 8, Citrus: 5 },
      },
      {
        text: "YSL Black Opium",
        subtext: "",
        recommendations: { Coffee: 8, Vanilla: 5 },
      },
      {
        text: "Dior J'adore",
        subtext: "",
        recommendations: { Jasmine: 8, Floral: 5 },
      },
      {
        text: "Chanel No. 5",
        subtext: "",
        recommendations: { Jasmine: 8, Amber: 5 },
      },
      {
        text: "Byredo Gypsy Water",
        subtext: "",
        recommendations: { Amber: 8, Jasmine: 5 },
      },
      {
        text: "Khamrah Qahwa",
        subtext: "",
        recommendations: { Coffee: 8, Amber: 5 },
      },
      {
        text: "YSL Libre",
        subtext: "",
        recommendations: { Vanilla: 8, Amber: 5 },
      },
      {
        text: "Paco Rabanne Black XS for Her",
        subtext: "",
        recommendations: { Coffee: 5, Vanilla: 5, Floral: 3 },
      },
      {
        text: "Carolina Herrera Good Girl",
        subtext: "",
        recommendations: { Coffee: 5, Jasmine: 5, Vanilla: 5 },
      },
      { text: "None of these", subtext: "", recommendations: {} },
    ],
  },
  {
    text: "Let's get to the heart of it",
    choices: [
      {
        text: "Floral",
        subtext: "(Classic and eternally elegant)",
        recommendations: { Jasmine: 8 },
      },
      {
        text: "Woody",
        subtext: "(Rich and grounding)",
        recommendations: { Amber: 8 },
      },
      {
        text: "Gourmand",
        subtext: "(Sweet and indulgent)",
        recommendations: { Vanilla: 8, Coffee: 5 },
      },
      {
        text: "Citrus",
        subtext: "(Bright and uplifting)",
        recommendations: { Jasmine: 5, Vanilla: 3 },
      },
    ],
  },
  {
    text: "Last but not least - how much of a statement are we making? 💁‍♀️",
    choices: [
      {
        text: "Light and airy scent",
        subtext: "(Subtle and fresh)",
        recommendations: { Jasmine: 8 },
      },
      {
        text: "Moderate scent",
        subtext: "(Balanced and versatile)",
        recommendations: { Vanilla: 8, Coffee: 5 },
      },
      {
        text: "Strong and intense scent",
        subtext: "(Bold and lasting)",
        recommendations: { Amber: 8, Coffee: 5 },
      },
    ],
  },
];

const products = ["Vanilla", "Amber", "Coffee", "Jasmine"];

// Initialize scores
let scores = {};
products.forEach((product) => (scores[product] = 0));

let currentQuestion = 0;

// --- DOM Elements ---
const questionEl = document.getElementById("question");
const answersEl = document.getElementById("answers");
const nextButton = document.getElementById("next-button");
const prevButton = document.getElementById("prev-button");
const resultsEl = document.getElementById("results");
const productNameEl = document.getElementById("product-name");
const productContentEl = document.getElementById("product-con");
const addtocartBtn = document.getElementById("addtocart_btn");
const productImageEl = document.getElementById("product-image");
const productImageEl1 = document.getElementById("product-image1");
const productLinkEl = document.getElementById("product-link");
const countsec = document.getElementById("countsec");
const customerSection = document.getElementById("customersection");
const lastShowSec = document.getElementById("lastshow-sec");
const lastShowPopup = document.getElementById("lastshow-popup");
const skipSec = document.getElementById("skipsec");
const SubscribeBtn = document.getElementById("Subscribe");
const emailSec = document.getElementById("emailsec");
const phoneSec = document.getElementById("phone");

// --- Display Question Function ---
function displayQuestion() {
  if (currentQuestion < questions.length) {
    const question = questions[currentQuestion];
    questionEl.innerHTML = `${question.text} <span>(select upto 2 options)</span>`;
    answersEl.innerHTML = "";

    let selectedCheckboxes = [];

    question.choices.forEach((choice, index) => {
      const label = document.createElement("label");
      label.classList.add("answer-label"); // Add a class for styling
      label.setAttribute("for", `choice-${index}`);
      const input = document.createElement("input");
      input.type = "checkbox"; // Use checkboxes for multiple choice
      input.name = "question";
      input.value = index;
      input.id = `choice-${index}`;
      const spancontent = document.createElement("span");

      //Toggle active class when label is clicked
      input.addEventListener("change", function () {
        if (this.checked) {
          selectedCheckboxes.push(this);
          if (selectedCheckboxes.length > 2) {
            let removedCheckbox = selectedCheckboxes.shift(); // Remove the first selected
            removedCheckbox.checked = false;
            removedCheckbox.parentElement.classList.remove("active");
          }
          label.classList.add("active");
        } else {
          selectedCheckboxes = selectedCheckboxes.filter((cb) => cb !== this);
          label.classList.remove("active");
        }
      });

      label.appendChild(spancontent);
      label.appendChild(input);
      label.append(choice.text);
      spancontent.append(choice.subtext);
      answersEl.appendChild(label);
    });

    // Update prompt for selecting multiple answers
    const prompt = document.createElement("p");
    prompt.textContent = "(Select up to two answers)";
    answersEl.appendChild(prompt);
    
  } else {
    calculateRecommendation();

      customerSection.style.display = "none";
        lastShowSec.style.display = "flex"; 

      setTimeout(function(){
        lastShowPopup.style.display = "flex";
      },3000);

      skipSec.addEventListener("click", () => {
        //alert("Hello");
        //debugger;
        calculateRecommendation();
        // Call this function when you want to send data to the Google Sheet
    sendRecommendationsToGoogleSheet();
        customerSection.style.display = "block";
        lastShowSec.style.display = "none"; 
        lastShowPopup.style.display = "none"; 
        setTimeout(function(){ 
                $('.recipeaddtocart-sectioninner').slick('refresh');
              },1000);
      })

      SubscribeBtn.addEventListener("click", () => {
  
        var emailval = emailSec.value;
        var phoneval = phoneSec.value;
        
        console.log('Phone Number', phoneval);
          function valid(email) {
              const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              return pattern.test(emailval);
          }
        
          if(valid(emailval)){
            //alert("Valid email address");
            document.getElementById("messagesec").innerHTML = `<span style="color:green;">Email Submit</span>`;
            var productNameText = localStorage.getItem("productdataName");
            console.log("emailval", emailval);
            console.log("phoneval", phoneval);
            console.log("Product Name", productNameText);
            // Create the object
              const userData = {
                  email: emailval,
                  phone: phoneval,
                  productName: productNameText
              };
              
              // Store it in localStorage
              localStorage.setItem("userData", JSON.stringify(userData));
              // Call this function when you want to send data to the Google Sheet
            sendRecommendationsToGoogleSheet();
            setTimeout(function(){  
              calculateRecommendation();
              customerSection.style.display = "block";
              lastShowSec.style.display = "none"; 
              lastShowPopup.style.display = "none";  
              
              setTimeout(function(){ 
                $('.recipeaddtocart-sectioninner').slick('refresh');
              },1000);
            },2000);
          }else{
            //alert("Invalid email address");
            document.getElementById("messagesec").innerHTML = `<span style="color:red;">Inalid email address</span>`;
            
          }
          
          
          //console.log("emailval", emailval);
        })
    
    
  }
}

// --- Calculate Recommendation Function ---
function calculateRecommendation() {
  let recommendedProduct = products[0];
  let maxScore = scores[recommendedProduct];
  for (let i = 1; i < products.length; i++) {
    if (scores[products[i]] > maxScore) {
      maxScore = scores[products[i]];
      recommendedProduct = products[i];
    }
  }
  

  // Get product data (replace with actual Shopify product data)
  const productData = {
    Vanilla: {
      name: "Vanilla Whispers",
      text: "Look who's bringing the sweet life to the party! The votes are in: you're sweet with a side of sass, and Vanilla Whispers is your perfect match.",
      image:
        "https://cdn.shopify.com/s/files/1/0732/4188/6977/files/Group_108.png?v=1739419657",
      desktopImage:
        "https://cdn.shopify.com/s/files/1/0732/4188/6977/files/vanilla.webp?v=1740461059",
      productId: "45972406534401",
      class: "vanilla-sec",
      link: "/products/antique-drawers",
      productList: {
        product1: {
          title: "Amber Elixir",
          productID: "46054273974529",
          scent_title: "Golden Hour",
          para: "Warm, Luxurious, Seductive",
          amText: "Vanilla PM",
          pmText: "Amber AM",
        },
        product2: {
          title: "Forbidden Jasmine",
          productID: "46054257590529",
          scent_title: "Timeless Grace",
          para: "Classic, Elegant, Refined",
          amText: "Vanilla AM",
          pmText: "Jasmine AM",
        },
        product3: {
          title: "Café Noir",
          productID: "46054263161089",
          scent_title: "Velvet Morning",
          para: "Cozy, Warm, Inviting",
          amText: "Vanilla AM",
          pmText: "Coffee PM",
        },
      },
    },
    Amber: {
      name: "Amber Elixir",
      text: "Well well well, look who's here to make an entrance! The boss energy is strong with this one, and Amber Elixir has your name written all over it.",
      image:
        "https://cdn.shopify.com/s/files/1/0732/4188/6977/files/QUIZ_ecaf0c2b-aed4-4211-ad03-02d453d14874.png?v=1740147535",
      desktopImage:
        "https://cdn.shopify.com/s/files/1/0732/4188/6977/files/amber.webp?v=1740461060",
      productId: "46054273974529",
      class: "amber-sec",
      link: "/products/bedside-table",
      productList: {
        product1: {
          title: "Vanilla Whispers",
          productID: "45972406534401",
          scent_title: "Power Move",
          para: "Confident, Luxurious, Commanding",
          amText: "Amber AM",
          pmText: "Vanilla AM",
        },
        product2: {
          title: "Café Noir",
          productID: "46054263161089",
          scent_title: "Bold Spirit",
          para: "Daring, Intense, Unforgettable",
          amText: "Amber PM",
          pmText: "Coffee PM",
        },
        product3: {
          title: "Forbidden Jasmine",
          productID: "8727497310465",
          scent_title: "Sunset Dreams",
          para: "Warm, Romantic, Dreamy ",
          amText: "Amber PM",
          pmText: "Jasmine PM",
        },
      },
    },
    Coffee: {
      name: "Cafe Noir",
      text: "Plot twist: your perfect match is anything but ordinary! Confident and a little mysterious? We absolutely see you.",
      image:
        "https://cdn.shopify.com/s/files/1/0732/4188/6977/files/coffee.png?v=1739419657",
      desktopImage:
        "https://cdn.shopify.com/s/files/1/0732/4188/6977/files/typsy-beauty-LIT00132_2_1.png?v=1740478689",
      productId: "46054263161089",
      class: "coffee-sec",
      link: "/products/biodegradable-cardboard-pots",
      productList: {
        product1: {
          title: "Vanilla Whispers",
          productID: "45972406534401",
          scent_title: "Midnight Whispers",
          para: "Mysterious, Seductive, Indulgent",
          amText: "Coffee PM",
          pmText: "Vanilla PM",
        },
        product2: {
          title: "Amber Elixir",
          productID: "46054273974529",
          scent_title: "Dark Romance",
          para: "Bold, Intense, Captivating",
          amText: "Coffee AM",
          pmText: "Amber PM",
        },
        product3: {
          title: "Forbidden Jasmine",
          productID: "46054257590529",
          scent_title: "Morning Glow",
          para: "Fresh, Energetic, Sophisticated",
          amText: "Jasmine AM",
          pmText: "Coffee AM",
        },
      },
    },
    Jasmine: {
      name: "Forbidden Jasmine",
      text: "Fresh, floral, and a little bit fancy - we see you! Meet your scent spirit animal, Forbidden Jasmine, where timeless elegance meets modern-day magic.",
      image:
        "https://cdn.shopify.com/s/files/1/0732/4188/6977/files/Group_107.png?v=1739419657",
      desktopImage:
        "https://cdn.shopify.com/s/files/1/0732/4188/6977/files/jasmine.webp?v=1740461059",
      productId: "46054257590529",
      class: "jasmine-sec",
      link: "/products/black-bean-bag",
      productList: {
        product1: {
          title: "Vanilla Whispers",
          productID: "45972406534401",
          scent_title: "Sweet Elegance",
          para: "Graceful, Sweet, Delicate",
          amText: "Jasmine AM",
          pmText: "Vanilla AM",
        },
        product2: {
          title: "Amber Elixir",
          productID: "46054273974529",
          scent_title: "Night Queen",
          para: "Regal, Sophisticated, Captivating",
          amText: "Jasmine PM",
          pmText: "Amber AM",
        },
        product3: {
          title: "Café Noir",
          productID: "46054263161089",
          scent_title: "Midnight Maven",
          para: "Mysterious, Alluring, Complex",
          amText: "Jasmine PM",
          pmText: "Coffee PM",
        },
      },
    },
  };
  var productdataName = productData[recommendedProduct].name;
  localStorage.setItem("productdataName", productdataName);
  productNameEl.textContent = productData[recommendedProduct].name;
  productImageEl.src = productData[recommendedProduct].image;
  productImageEl1.src = productData[recommendedProduct].desktopImage;
  productLinkEl.href = productData[recommendedProduct].link;
  productContentEl.textContent = productData[recommendedProduct].text;
  addtocartBtn.setAttribute(
    "data-id",
    productData[recommendedProduct].productId
  );
  results.classList.add(productData[recommendedProduct].class);
  document.getElementById("product_title").textContent =
    productData[recommendedProduct].productList.product1.title;
  document.getElementById("product_title1").textContent =
    productData[recommendedProduct].productList.product2.title;
  document.getElementById("product_title2").textContent =
    productData[recommendedProduct].productList.product3.title;
  document.getElementById("product_title").textContent =
    productData[recommendedProduct].productList.product1.title;
  document.getElementById("product_title1").textContent =
    productData[recommendedProduct].productList.product2.title;
  document.getElementById("product_title2").textContent =
    productData[recommendedProduct].productList.product3.title;
  document.getElementById("scent_title").textContent =
    productData[recommendedProduct].productList.product1.scent_title;
  document.getElementById("scent_title1").textContent =
    productData[recommendedProduct].productList.product2.scent_title;
  document.getElementById("scent_title2").textContent =
    productData[recommendedProduct].productList.product3.scent_title;
  document.getElementById("scent_text").textContent =
    productData[recommendedProduct].productList.product1.para;
  document.getElementById("scent_text1").textContent =
    productData[recommendedProduct].productList.product2.para;
  document.getElementById("scent_text2").textContent =
    productData[recommendedProduct].productList.product3.para;
  document.getElementById("amtext").textContent =
    productData[recommendedProduct].productList.product1.amText;
  document.getElementById("amtext1").textContent =
    productData[recommendedProduct].productList.product2.amText;
  document.getElementById("amtext2").textContent =
    productData[recommendedProduct].productList.product3.amText;
  document.getElementById("pmtext").textContent =
    productData[recommendedProduct].productList.product1.pmText;
  document.getElementById("pmtext1").textContent =
    productData[recommendedProduct].productList.product2.pmText;
  document.getElementById("pmtext2").textContent =
    productData[recommendedProduct].productList.product3.pmText;
  document
    .getElementById("addtocart_scent")
    .setAttribute(
      "data-id",
      productData[recommendedProduct].productList.product1.productID
    );
  document
    .getElementById("addtocart_scent1")
    .setAttribute(
      "data-id",
      productData[recommendedProduct].productList.product2.productID
    );
  document
    .getElementById("addtocart_scent2")
    .setAttribute(
      "data-id",
      productData[recommendedProduct].productList.product3.productID
    );

  // Show results
  questionEl.style.display = "none";
  answersEl.style.display = "none";
  nextButton.style.display = "none";
  prevButton.style.display = "none";
  resultsEl.style.display = "flex";

  
}

const progressBar = document.getElementById("progress-bar");

function updateProgressBar() {
  //console.log("currentQuestion", currentQuestion);
  var questionNumber = currentQuestion + 1;
  let progress = (questionNumber / questions.length) * 100;
  progressBar.style.width = progress + "%";
}

const messages = [
  '"Love where this is going..."',
  '"The plot thickens... ✨"',
  '"All Spritz fragrances have 20-40% fragrance oil, making it the most concentrated form of perfume, ensuring a richer, more intense scent"',
  '"Perfect pick! Lets keep going..."',
  '"A scent to remember! Next..."',
  '"All spritz fragrances are Vegan, cruelty free and IFRA certified and safe for sensitive skin"',
  '"The pieces are falling into place..."',
];

const randomMessageEl = document.getElementById("random-message");

nextButton.addEventListener("click", () => {
  const selectedAnswers = document.querySelectorAll(
    "input[name='question']:checked"
  );
  const answersText = document.querySelectorAll(".answer-label").textContext;
  var countNumber = countsec.innerHTML;
  var countNumber = Number(countNumber);
  //console.log("countNumber", countNumber);

  if (selectedAnswers.length > 0 && selectedAnswers.length <= 2) {
    prevButton.style.display = "inline";
    if (countNumber < 8) {
      countsec.innerHTML = countNumber + 1;
    } else {
      document.querySelector(".question-count").style.display = "none";
      document.querySelector("#progress-container").style.display = "none";
    }

    if (countNumber == 7) {
      nextButton.textContent = "Finish >";
    }

    // Retrieve existing recommendations grouped by question or initialize an empty object
    let savedRecommendations =
      JSON.parse(localStorage.getItem("questionRecommendations")) || {};

    selectedAnswers.forEach((selectedAnswer) => {
      const choiceIndex = parseInt(selectedAnswer.value);
      const recommendationsText =
        questions[currentQuestion].choices[choiceIndex].text;

      //console.log("recommendationsText", recommendationsText);

      // Check if the current question already exists in storage, if not, create an array
      if (!savedRecommendations[currentQuestion]) {
        savedRecommendations[currentQuestion] = [];
      }

      // Add new recommendation text to the question array
      savedRecommendations[currentQuestion].push(recommendationsText);

      // Update scores (if needed)
      updateScores(
        questions[currentQuestion].choices[choiceIndex].recommendations
      );
    });

    // Save updated object back to localStorage
    localStorage.setItem(
      "questionRecommendations",
      JSON.stringify(savedRecommendations)
    );

    // Log to verify
    //console.log("Updated Recommendations by Question:", savedRecommendations);

    // Hide current question
    questionEl.style.display = "none";
    answersEl.style.display = "none";
    nextButton.style.display = "none";
    prevButton.style.display = "none";

    // Show different text for each question
    randomMessageEl.textContent =
      messages[Math.min(currentQuestion, messages.length - 1)];
    randomMessageEl.classList.add("show");
    document.querySelector(".question-count").classList.add("show");
    document.querySelector("#progress-container").classList.add("show");
    document.querySelector("#progress-container").classList.add("show");
    randomMessageEl.style.display = "block";

    // Wait 2 seconds, then show the next question
    setTimeout(() => {
      document.querySelector("body").classList.add(`style-${countNumber + 1}`);
      document.querySelector("body").classList.remove(`style-${countNumber}`);
      document.querySelector(".question-count").classList.remove("show");
      document.querySelector("#progress-container").classList.remove("show");
      randomMessageEl.classList.remove("show");
      randomMessageEl.style.display = "none"; // Hide message
      questionEl.style.display = "block"; // Show question
      answersEl.style.display = "block";
      nextButton.style.display = "inline-block";
      prevButton.style.display = currentQuestion > 0 ? "inline-block" : "none"; // Show prev button if not first question

      currentQuestion++;
      updateProgressBar();
      displayQuestion();
    }, 200); // 2-second delay
  } else {
    //alert("Please select one or two answers.");
  }
});

// --- Back Button Click Handler ---
prevButton.addEventListener("click", () => {
  //console.log("currentQuestion", currentQuestion);
  var countNumber = countsec.innerHTML;
  var countNumber = Number(countNumber);
  //debugger;
  //prevButton.style.display = "none";

  nextButton.textContent = "Next >";
  document.querySelector("body").classList.add(`style-${countNumber - 1}`);
  document.querySelector("body").classList.remove(`style-${countNumber}`);
  if (countNumber > 1) {
    countsec.innerHTML = countNumber - 1;
  }
  if (countNumber == 2) {
    prevButton.style.display = "none";
  }
  if (currentQuestion > 0) {
    //elem.style.width = width + "%";
    currentQuestion--;
    updateProgressBar();
    displayQuestion();
    //prevButton.style.display = "inline";
    //alert("Hello");
  } else {
    prevButton.style.display = "none";
    alert("You are on the first question.");
  }
});

// --- Update Scores Function ---
function updateScores(recommendations) {
  for (const product in recommendations) {
    scores[product] += recommendations[product];
  }
}

// --- Start the Quiz ---
displayQuestion();




function sendRecommendationsToGoogleSheet() {
  let savedRecommendations = JSON.parse(localStorage.getItem("questionRecommendations")) || {};
  const storedData = JSON.parse(localStorage.getItem("userData")) || {};
  console.log("Retrieved Data:", storedData);
  //console.log(savedRecommendations, "savedRecommendations");
  var formData = {};
  formData.looking = savedRecommendations[0].toString();
  formData.mood = savedRecommendations[1].toString();
  formData.drink = savedRecommendations[2].toString();
  formData.weather = savedRecommendations[3].toString();
  formData.scents  = savedRecommendations[4].toString();
  formData.favorites = savedRecommendations[5].toString();
  formData.heart = savedRecommendations[6].toString();
  formData.statement  = savedRecommendations[7].toString();
  formData.email = storedData.email; //Raj to add data
  formData.mobile = storedData.phone;//Raj to add data
  formData.recommendedProduct = storedData.productName;//Raj to add data
  console.log("email next", storedData.email);
  console.log("phone next", storedData.phone);
  console.log("productName next", storedData.productName);

  //console.log(formData);
  //console.log(JSON.stringify(formData));
  fetch(
    "https://gedemo.in/lovedepot/api/typsy/setQuizData",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    }
  )
    .then((response) => response.text())
    .then((data) => console.log("Server Response:", data))
    .catch((error) => console.error("Error:", error));
}
